/* eslint-disable */

import {HiX} from "react-icons/hi";
import Links from "./components/Links";

// import SidebarCard from "components/sidebar/components/SidebarCard";
// import routes from "routes2.js"
import routesSuperAdmin from "../../routesSuperAdmin";
import routesFirmware from "../../routesFirmware";

import CromptonLogo from "../../assets/img/layout/Crompton SENZE LOGO Final_2.png";
import CromptonLogoDark from "../../assets/img/layout/Crompton SENZE LOGO Final_3.png";

// import avatar4 from "assets/img/avatars/avatar4.png";
import Card from "../card2";
import {useUserAuth} from "../../context/UserAuthContext";
import routesUser from "../../routesUser";
import routesMarketing from "../../routesMarketing";
import routesAppDeveloper from "../../routesAppDeveloper";
import routesAnalyticsUser from "../../routesAnalyticsUser";
import routesRecipe from "../../routesRecipe";

/*const Sidebar = ({ open, onClose }) => {
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[16px] mt-[50px] flex items-center`}>
        <div className="mt-1 ml-1 h-2.5 font-poppins text-[32px] font-bold text-navy-700 dark:text-white">
          Crompton <span className="font-bold text-[32px]  text-[#004c86] ms-1 dark:text-[#004c86]">SENZE</span>
        </div>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      {/!* Nav item *!/}

      <ul className="mb-auto pt-1">
        <Links routes={routes} />
      </ul>

      {/!* Free Horizon Card *!/}
      {/!*<div className="flex justify-center">
        <SidebarCard />
      </div>*!/}

      {/!* Nav item end *!/}
    </div>
  );
};*/

function SidebarHorizon(props) {
    const {open, onClose, variant, mini} = props;
    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    return (
        <div
            className={`sm:none ${
                mini === false ? "w-[305px]" : "w-[305px] xl:!w-[120px]"
            } duration-175 linear fixed !z-50 flex min-h-full transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
                variant === "auth" ? "xl:hidden" : "xl:block"
            } ${open ? "" : "-translate-x-[105%]"}`}
        >
            <Card
                extra={`w-full h-[100vh]`}>
                <div className="flex h-full flex-col justify-between">
                    <div>
              <span
                  className="absolute top-4 right-4 block cursor-pointer xl:hidden"
                  onClick={onClose}
              >
                <HiX/>
              </span>
                        <div className="flex flex-col items-center mt-[25px] px-0 transition-all duration-300">
                            {/* Light Mode Logo */}
                            <img
                                src={CromptonLogo}
                                alt="Crompton Logo"
                                className={`dark:hidden transition-all duration-300 ${
                                    mini === false || (mini === true && hovered === true)
                                        ? "h-[65px] w-auto"
                                        : "h-[40px] w-auto"
                                }`}
                            />

                            {/* Dark Mode Logo */}
                            <img
                                src={CromptonLogoDark}
                                alt="Crompton Logo Dark"
                                className={`hidden dark:block transition-all duration-300 ${
                                    mini === false || (mini === true && hovered === true)
                                        ? "h-[65px] w-auto"
                                        : "h-[38px] w-auto"
                                }`}
                            />
                        </div>

                        <div className="mt-[28px] mb-7 h-px bg-gray-300 dark:bg-white/10"/>

                        {/* Nav item */}
                        <ul>
                            {accesscontrollevel.toString() === "2" &&
                                <Links mini={mini} hovered={false} routes={routesFirmware}/>}
                            {accesscontrollevel.toString() === "1" &&
                                <Links mini={mini} hovered={false} routes={routesSuperAdmin}/>}
                            {accesscontrollevel.toString() === "0" &&
                                <Links mini={mini} hovered={false} routes={routesUser}/>}
                            {accesscontrollevel.toString() === "3" &&
                                <Links mini={mini} hovered={false} routes={routesMarketing}/>}
                            {accesscontrollevel.toString() === "4" &&
                                <Links mini={mini} hovered={false} routes={routesAppDeveloper}/>}
                            {accesscontrollevel.toString() === "5" &&
                                <Links mini={mini} hovered={false} routes={routesAnalyticsUser}/>}
                            {accesscontrollevel.toString() === "6" &&
                                <Links mini={mini} hovered={false} routes={routesRecipe}/>}
                            {/*<Links mini={mini} hovered={hovered} routes={routes}/>*/}
                        </ul>
                    </div>
                </div>
            </Card>
        </div>
    );
}

export default SidebarHorizon;
